import React from 'react';
import { Card } from 'antd';
import { ResellerFeatures } from '../types';
import FormInput from './FormInput';
import VoiceProviderInput from './VoiceProviderInput';
import { VOICE_PROVIDERS } from '../constants';

interface ResellerFeaturesFormProps {
	resellerFeatures: ResellerFeatures;
	updateFormData: (updates: any) => void;
}

const ResellerFeaturesForm: React.FC<ResellerFeaturesFormProps> = ({
	resellerFeatures,
	updateFormData,
}) => {
	const handleVoiceCreditsChange = (value: any): void => {
		updateFormData({
			features: {
				...resellerFeatures,
				voiceCredits: value as number,
			} as ResellerFeatures,
		});
	};

	const handleSMSCreditsChange = (value: any): void => {
		updateFormData({
			features: {
				...resellerFeatures,
				smsCredits: value as number,
			} as ResellerFeatures,
		});
	};

	const handleVoiceProviderChange = (
		provider: keyof typeof VOICE_PROVIDERS,
		value: number,
	): void => {
		const updatedFeatures = {
			...resellerFeatures,
			overageVoiceCharges: {
				...resellerFeatures?.overageVoiceCharges,
				charges: {
					...resellerFeatures?.overageVoiceCharges?.charges,
					[provider]: value,
				},
			},
		} as ResellerFeatures;
		updateFormData({ features: updatedFeatures });
	};

	return (
		<div className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
				<FormInput
					label="Voice Credits"
					value={resellerFeatures?.voiceCredits || 0}
					onChange={handleVoiceCreditsChange}
					type="number"
				/>

				<FormInput
					label="SMS Credits"
					value={resellerFeatures?.smsCredits || 0}
					onChange={handleSMSCreditsChange}
					type="number"
				/>
			</div>

			<Card title="Voice Provider Pricing" className="border rounded-lg">
				<div className="grid grid-cols-2 md:grid-cols-3 gap-4">
					{Object.entries(VOICE_PROVIDERS).map(([provider, _label]) => (
						<VoiceProviderInput
							key={provider}
							provider={provider as keyof typeof VOICE_PROVIDERS}
							value={
								resellerFeatures?.overageVoiceCharges?.charges?.[
									provider as keyof typeof VOICE_PROVIDERS
								] || (provider === 'transferredCall' ? 0.03 : 0.12)
							}
							onChange={(value) =>
								handleVoiceProviderChange(provider as keyof typeof VOICE_PROVIDERS, value)
							}
						/>
					))}
				</div>
			</Card>
		</div>
	);
};

export default ResellerFeaturesForm;
